<template>
  <div class="modal-body text-break" v-text="message" />
</template>

<script>
export default {
  name: "ModalBody",
   inject: [
    '$moment',
  ],
  props: {
    message: {
      type: String,
      required: true,
    },
  }
}
</script>

<style scoped>
.modal-body {
  min-height: 100px;
  margin-top: 10px;
}
</style>
